"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebounce = void 0;
var use_debounce_1 = require("./use-debounce");
Object.defineProperty(exports, "useDebounce", { enumerable: true, get: function () { return __importDefault(use_debounce_1).default; } });
//# sourceMappingURL=index.js.map